export default __webpack_public_path__ + "static/media/UPF5G.d5db247d.png";